export const URL_ROOT = 'https://product-assets.iheartjane.com/default-photos/';

// We're not using the taxonomy repo here because it has no way of knowing which type/subtypes
// have files present in the S3 bucket of assets.

export const ROOT_SUBTYPE_PATHS: {
  [index: string]: { [index: string]: boolean };
} = {
  edible: {
    bakedgoods: true,
    bars: true,
    breathstrips: true,
    candies: true,
    capsules: true,
    chocolates: true,
    cooking: true,
    driedfruit: true,
    drinkmixes: true,
    drinks: true,
    honeys: true,
    icecreams: true,
    mints: true,
    other: true,
    pets: true,
    sauces: true,
    seasoningsugar: true,
    smallbites: true,
    snacks: true,
    spreads: true,
    teascoffee: true,
  },
  extract: {
    diamondscrystals: true,
    distillates: true,
    hash: true,
    inhalation: true,
    isolates: true,
    kief: true,
    moonrocks: true,
    oils: true,
    ricksimpsonoilrso: true,
    rosins: true,
    sauces: true,
    shatters: true,
    syringestankers: true,
    vapekits: true,
    waxes: true,
  },
  flower: {
    cbd: true,
    hybrid: true,
    indica: true,
    sativa: true,
    shake: true,
  },
  gear: {
    accessories: true,
    clothing: true,
    cones: true,
    grinders: true,
    papers: true,
    paraphernalia: true,
    tips: true,
    vaporizers: true,
    wraps: true,
  },
  general: {
    cbd: true,
    edible: true,
    extract: true,
    gear: true,
    grow: true,
    hybrid: true,
    indica: true,
    merch: true,
    preroll: true,
    sativa: true,
    tincture: true,
    topical: true,
  },
  grow: {
    clones: true,
    seeds: true,
  },
  merch: {
    clothing: true,
    jewelry: true,
    kits: true,
    other: true,
  },
  preroll: {
    bluntpacks: true,
    blunts: true,
    cannagars: true,
    infused: true,
    infusedblunts: true,
    infusedpacks: true,
    prerollpacks: true,
    prerolls: true,
    thaisticks: true,
  },
  tincture: {
    companions: true,
    pets: true,
    sprays: true,
    sublinguals: true,
    tinctures: true,
  },
  topical: {
    balms: true,
    bath: true,
    companions: true,
    cosmetics: true,
    creams: true,
    gels: true,
    intimates: true,
    lipbalms: true,
    lotions: true,
    oils: true,
    ointments: true,
    patches: true,
    pets: true,
    rollons: true,
    salves: true,
    scrubs: true,
    soaps: true,
    sprays: true,
    suppositories: true,
  },
  vape: {
    cartridges: true,
    disposables: true,
    specialtypods: true,
  },
};
